export const APP_NAME = "CLB";
export const APP_SEPARATOR = "-";
